import dayjs from "dayjs";

export const transformExposureData = (data, title, graphColor) => {
  return {
    series: [
      {
        name: title,
        data: data?.map((item) => item?.exposureValue),
        color: graphColor,
      },
    ],
    labels: data?.map((item) => dayjs(item?.date).format("MMM DD")),
  };
};

export const transformUniqueUsersData = (
  data,
  name = "Unique Users",
  color = "#3256b8"
) => {
  return {
    series: [
      {
        name,
        data: data?.map((item) => item?.uniqueUsers),
        color,
      },
    ],
    labels: data?.map((item) => dayjs(item?.date).format("MMM DD")),
  };
};

export const transformConsentedUniqueUsers = (
  data,
  titles = ["Unique Users Cumulative", "Unique Users Per Day"],
  graphColor = ["#1aa053", "#3256b8"]
) => {
  return {
    series: [
      {
        name: titles.at(0),
        type: "column",
        data: data?.map((item) => item?.userCountCumulative),
        color: graphColor.at(0),
      },
      {
        name: titles.at(1),
        type: "line",
        data: data?.map((item) => item?.userCountPerDay),
        color: graphColor.at(1),
      },
    ],
    labels: data?.map((item) => dayjs(item?.date).format("MMM DD")),
  };
};

export const transformDemoScheduleStatus = (data) => {
  const filteredData = data?.filter((item) => item?.percentage > 0) || [];
  return {
    series: filteredData?.map((item) => item?.percentage),
    labels: filteredData?.map((item) => formatPageTitle(item?.status)),
  };
};

export const transformDemoMedium = (data) => {
  const filteredData = data?.filter((item) => item?.percentage > 0) || [];
  return {
    series: filteredData?.map((item) => item?.percentage),
    labels: filteredData?.map((item) => formatPageTitle(item?.status)),
  };
};

export const transformNpsScoreData = (data, label = []) => {
  return {
    series: data?.map((item) => ({
      name: item?.category,
      data: [item?.score],
    })),
    label: label,
  };
};

export const transformPrescribersPercentageData = (data) => {
  return {
    labels: data?.map((item) =>
      capitalizeFirstWord(formatPageTitle(item?.status))
    ),
    series: data?.map((item) => item?.value),
  };
};

export const transformPrescribersSatisfactionScoreData = (data, title) => {
  return {
    series: [
      {
        name: title,
        data: data?.map((item) => item?.value),
      },
    ],
    labels: data?.map((item) => item?.title),
  };
};

export const updatePageMenuValues = (pageMenu, values) => {
  if (!values || typeof values !== "object") {
    return pageMenu;
  }
  return pageMenu.map((item) => {
    if (values[item.id]) {
      return {
        ...item,
        value: values[item.id].toLocaleString() || "0",
      };
    }
    return item;
  });
};

export const getCalanderEvents = (eventData = []) => {
  const formattedEvents = eventData.map((event) => ({
    title: event.title,
    start: event.start_date,
    end: event.end_date,
    allDay: event.allDay === 1,
    backgroundColor: event.backgroundColor,
    borderColor: event.borderColor,
  }));
  return formattedEvents || [];
};

export const transformStateData = (data = []) => {
  if (!Array.isArray(data)) return [{}];

  const transformedObject = data.reduce((acc, item) => {
    if (item?.state && item?.count !== undefined) {
      acc[item.state] = item.count;
    }
    return acc;
  }, {});

  return [transformedObject];
};

export const formatPageTitle = (key = "") => {
  if (typeof key !== "string") return key;
  return key
    ?.replace(/_/g, " ")
    ?.replace(/\b\w/g, (char) => char?.toUpperCase());
};

export const maskText = (str = "", ignoreDepth = 0) => {
  let res = str.split(" ");
  for (let i = 0; i < res.length; i++) {
    if (i < ignoreDepth) continue;
    if (res[i].length === 1) {
      continue;
    } else if (res[i].length === 2) {
      res[i] = res[i][0] + "*";
    } else {
      res[i] = res[i][0] + res[i][1] + "*".repeat(res[i].length - 2);
    }
  }
  return res.join(" ");
};

const capitalizeFirstWord = (text = "") => {
  const words = text.split(" ");
  if (words.length > 1) {
    return words[0].toUpperCase() + " " + words.slice(1).join(" ");
  }
  return text.toUpperCase();
};
